// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"08af8b20","208":"4b73d4b1","372":"cc465223","553":"a8a076ae","788":"09e6577f","789":"104c3a46","882":"99e08521"}[chunkId] + ".chunk.css";
};